import type { Activity } from "./data.types";
import type { SportsFilter } from "./filters.types";

export type ActivityTableRow = Pick<
  Activity,
  | "strava_activity_id"
  | "start_date"
  | "name"
  | "type"
  | "sport_type"
  | "distance"
  | "moving_time"
  | "total_elevation_gain"
>;

export const TABLE_SORTABLE_COLUMNS = [
  "start_date",
  "name",
  "sport_type",
  "distance",
  "moving_time",
  "total_elevation_gain",
] as const satisfies readonly (keyof ActivityTableRow)[];

export type TableSortableColumn = (typeof TABLE_SORTABLE_COLUMNS)[number];

export type TableQueryOpts = {
  userId: string;
  pageIndex: number;
  pageSize: number;
  sortBy?: { id: TableSortableColumn; desc: boolean };
  search?: string;
  sports?: SportsFilter;
  from?: string; // ISO
  to?: string; // ISO
  limit?: number;
};
